// extracted by mini-css-extract-plugin
export var breadcrumb = "breadcrumb-module--breadcrumb--DWH7e";
export var breadcrumb_link = "breadcrumb-module--breadcrumb_link--grC-U";